/**
 * Double-line cell subline — MapPin + tag on NAME when assigned (#999).
 */

import React from 'react';
import { Text, type StyleProp, type TextStyle } from 'react-native';

import { LocationTagListSubline } from '../locationTags/LocationTagListSubline';

export interface RecordTableCellSublineProps {
  column: string;
  subline?: string;
  locationTagName?: string | null;
  textStyle?: StyleProp<TextStyle>;
  compact?: boolean;
  testID?: string;
}

export const RecordTableCellSubline: React.FC<RecordTableCellSublineProps> = ({
  column,
  subline,
  locationTagName,
  textStyle,
  compact = false,
  testID,
}) => {
  const tagName = locationTagName?.trim();
  if (column === 'NAME' && tagName) {
    return (
      <LocationTagListSubline
        locationTagName={tagName}
        subline={subline}
        style={textStyle}
        compact={compact}
        testID={testID}
      />
    );
  }

  return (
    <Text style={textStyle} numberOfLines={1}>
      {subline}
    </Text>
  );
};
